import {
  Sekcja,
  Glowna,
  Icon,
  Logo,
  Hyperlink,
  StyledLink,
  Container,
  Stopka,
  Linki,
} from "./styled";
import logo from "../../images/serce-finansow-16.png";
import { footer } from "./footer";

const Kontakt = () => {
  const scrollToUp = () => window.scrollTo({ top: 0 });

  return (
    <Sekcja>
      <Glowna>
        <Logo>
          <img src={logo} alt="Serce Finansów" width="1214" height="356" loading="lazy" decoding="async" />
          <Container>
            {footer.map(({ link, src, alt }) => (
              <Hyperlink
                key={alt}
                href={link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon src={src} alt={alt} width="40px" height="40px" />
              </Hyperlink>
            ))}
          </Container>
        </Logo>
      </Glowna>
      <Stopka>
        <p>© Copyright {new Date().getFullYear()} - Serce Finansów</p>
        <Linki>
          <StyledLink to="/#faq">Najczęstsze pytania</StyledLink>
          <p>|</p>
          <StyledLink to="/polityka-prywatności" onClick={scrollToUp}>
            Polityka Prywatności
          </StyledLink>
          <p>|</p>
          <StyledLink to="/regulamin" onClick={scrollToUp}>
            Regulamin
          </StyledLink>
        </Linki>
      </Stopka>
    </Sekcja>
  );
};

export default Kontakt;

